import React from 'react';
import { useTranslation } from 'react-i18next';
import { Btn, Portrait } from '../Common/OkoylUI';

const CLASS_IDS = ['sworder', 'mage', 'archer', 'tank'];
const CLASS_IMG = {
    sworder: '/assets/heroes/sworder.png',
    mage:    '/assets/heroes/mage.png',
    archer:  '/assets/heroes/archer.png',
    tank:    '/assets/heroes/tank.png',
};

const ClassSelection = ({ character, onSelectClass, onNext }) => {
    const { t } = useTranslation();
    const selectedName = character.classType
        ? t(`characterCreation.classes.${character.classType}.name`)
        : t('characterCreation.step1.noSelection');

    return (
        <div>
            <h2 className="okcard-title" style={{ marginBottom: 8 }}>{t('characterCreation.step1.title')}</h2>
            <div className="okrule okrule-thin" style={{ marginBottom: 20 }} />

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 16 }}>
                {CLASS_IDS.map(id => (
                    <div
                        key={id}
                        onClick={() => onSelectClass(id)}
                        style={{ cursor: 'pointer' }}
                    >
                        <Portrait
                            src={CLASS_IMG[id]}
                            name={t(`characterCreation.classes.${id}.name`)}
                            sub={t(`characterCreation.classes.${id}.sub`)}
                            selected={character.classType === id}
                        />
                        <div className="oklore oklore-sm" style={{ marginTop: 10, padding: '0 4px' }}>
                            {t(`characterCreation.classes.${id}.desc`)}
                        </div>
                    </div>
                ))}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 28 }}>
                <span className="oklore oklore-sm">
                    {t('characterCreation.step1.selection')}{' '}
                    <span style={{
                        color: 'var(--okoyl-200)',
                        fontStyle: 'normal',
                        fontFamily: 'var(--font-display)',
                        letterSpacing: '0.14em',
                        textTransform: 'uppercase',
                    }}>
                        {selectedName}
                    </span>
                </span>
                <Btn variant="primary" disabled={!character.classType} onClick={onNext}>
                    {t('common.next')} ▶
                </Btn>
            </div>
        </div>
    );
};

export default ClassSelection;
